import { render, staticRenderFns } from "./TeacherList.vue?vue&type=template&id=0d56d7d0&scoped=true&lang=pug"
import script from "./TeacherList.vue?vue&type=script&lang=ts"
export * from "./TeacherList.vue?vue&type=script&lang=ts"
import style0 from "./TeacherList.vue?vue&type=style&index=0&id=0d56d7d0&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d56d7d0",
  null
  
)

export default component.exports